import Modal from "bootstrap/js/dist/modal";
import { gsap } from "../layout"

// custom library
import { Fancybox } from "@fancyapps/ui";
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import ReadSmore from  'read-smore/dist/index.cjs'
import Choices from 'choices.js'
import flatpickr from "flatpickr";

function initFancyBox() {
    console.log(Fancybox)
    Fancybox.bind("[data-fancybox]", {
        // hideScrollbar: false,
    });
}

function gallerySwiper() {
    const containerSize = document.querySelector('.detail .custom-container').offsetWidth
    const windowSize = window.innerWidth
    const containerSpacing = (windowSize - containerSize) / 2

    if (windowSize <= 767) {
        document.querySelector('.gallery__swiper').style.marginLeft = containerSpacing + 'px'
        document.querySelector('.gallery__swiper').style.marginRight = containerSpacing + 'px'
    }

    const swiper = new Swiper('.gallery__swiper', {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        spaceBetween: 20,
        centeredSlides: true,
        loop: true,
        pagination: {
            el: '.gallery__swiper .swiper-pagination',
            dynamicBullets: true,
        },
        navigation: {
            nextEl: '.gallery .swiper-button-next',
            prevEl: '.gallery .swiper-button-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 1.8,
                spaceBetween: 60,
            }
        }
    });
}

function galleryCursor() {
    const cursor = document.querySelector('.cursor')

    cursor.innerHTML = '<div class="gallery__cursor"><span>Swipe</span><svg width="28" height="12" viewBox="0 0 28 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.375 4.125L1.5 6M1.5 6L3.375 7.875M1.5 6H10.5" stroke="#EAE5DF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M24.625 4.125L26.5 6M26.5 6L24.625 7.875M26.5 6H17.5" stroke="#EAE5DF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></div>'

    function onMouseMove(e) {
        gsap.to('.cursor', {
            top: e.clientY,
            left: e.clientX,
            duration: 0.9,
            ease: 'expo.out',
        })
    }

    const hoverArea = document.querySelector('.gallery__swiper')

    hoverArea.addEventListener('mouseenter', () => {

        gsap.to('.cursor', {
            autoAlpha: 1,
        })
    })

    hoverArea.addEventListener('mouseleave', () => {
        gsap.to('.cursor', {
            autoAlpha: 0,
        })
    })

    document.body.addEventListener('mousemove', (e) => {
        onMouseMove(e)
    })
}

function initReadsmore() {
    // target all read more elements
    const readMores = document.querySelectorAll('.js-read-smore')

    const iconArrowDown = '<svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.4417 7.56663C7.32451 7.68367 7.16566 7.74941 7.00003 7.74941C6.83441 7.74941 6.67556 7.68367 6.55837 7.56663L0.308368 1.31663C0.197968 1.19815 0.137866 1.04145 0.140722 0.87953C0.143579 0.717612 0.209173 0.563124 0.323683 0.448613C0.438194 0.334103 0.592682 0.268509 0.754599 0.265653C0.916517 0.262796 1.07322 0.322898 1.1917 0.433298L7.00003 6.24163L12.8084 0.433298C12.8656 0.371893 12.9346 0.322641 13.0113 0.288481C13.0879 0.254321 13.1707 0.235953 13.2546 0.234472C13.3385 0.232992 13.4219 0.248429 13.4997 0.279863C13.5775 0.311297 13.6482 0.358084 13.7076 0.417433C13.7669 0.476782 13.8137 0.547477 13.8451 0.6253C13.8766 0.703124 13.892 0.786481 13.8905 0.8704C13.889 0.954319 13.8707 1.03708 13.8365 1.11375C13.8024 1.19041 13.7531 1.25941 13.6917 1.31663L7.4417 7.56663Z" fill="#181F46"/></svg>'

    const iconArrowUp = '<svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.35356 0.146889C6.25981 0.0532556 6.13272 0.000662804 6.00022 0.000662804C5.86772 0.000662804 5.74064 0.0532556 5.64689 0.146889L0.64689 5.14689C0.55857 5.24167 0.510488 5.36704 0.512773 5.49657C0.515059 5.62611 0.567533 5.7497 0.659142 5.8413C0.750751 5.93291 0.874341 5.98539 1.00387 5.98767C1.13341 5.98996 1.25877 5.94188 1.35356 5.85356L6.00022 1.20689L10.6469 5.85356C10.6927 5.90268 10.7479 5.94208 10.8092 5.96941C10.8705 5.99674 10.9367 6.01143 11.0039 6.01262C11.071 6.0138 11.1377 6.00145 11.2 5.97631C11.2622 5.95116 11.3188 5.91373 11.3662 5.86625C11.4137 5.81877 11.4512 5.76221 11.4763 5.69996C11.5015 5.6377 11.5138 5.57101 11.5126 5.50388C11.5114 5.43674 11.4967 5.37053 11.4694 5.3092C11.4421 5.24786 11.4027 5.19266 11.3536 5.14689L6.35356 0.146889Z" fill="#322018"/></svg>'

    // Init
    ReadSmore(readMores, {
        moreText: `Show More ${iconArrowDown}`,
        lessText: `Show Less ${iconArrowUp}`,
    }).init()
}

function copyLink() {
    const buttonCopy = document.querySelector('.share-modal__copy')
    const linkEl = document.querySelector('.share-modal__input')
    
    buttonCopy.addEventListener('click', () => {
        linkEl.select();
        linkEl.setSelectionRange(0, 99999);
        navigator.clipboard.writeText(linkEl.value);
        // document.execCommand("copy");

        buttonCopy.innerHTML = 'Copied!'

        setTimeout(() => {
            buttonCopy.innerHTML = 'Copy'
        }, 3000);
    })
}

function appendJetbooking() {
    if (window.innerWidth <= 767) {
        const jetForm = document.querySelector('.price')
        const targetEl = document.querySelector('.price--mobile')

        targetEl.appendChild(jetForm)
    }
}

function choicesJs() {
    const preferedDay = document.querySelector('#preferedDay')

    if (preferedDay) {
        const choicesInq = new Choices(preferedDay, {
            searchEnabled: false,
            itemSelectText: ' ',
            allowHTML: true,
            shouldSort: false,
        });
    }
}

function incrementNumberGuest() {
    const targetEl = document.querySelector('#guest-adult .form__number')
    const plusButton = document.querySelector('#guest-adult .plus-button')
    const minButton = document.querySelector('#guest-adult .min-button')

    const targetElChild = document.querySelector('#guest-child .form__number')
    const plusButtonChild = document.querySelector('#guest-child .plus-button')
    const minButtonChild = document.querySelector('#guest-child .min-button')

    if (!targetEl) return

    function isGuestEmpty() {
        if (parseInt(targetEl.value) == 0 && parseInt(targetElChild.value) == 0) {
            targetEl.value = 1
        }
    }

    if (targetEl) {
        // targetEl.setAttribute('readonly', true)
    
        targetEl.value = 1
        
        plusButton.addEventListener('click', () => {
            if (parseInt(targetEl.value) < 10) {
                targetEl.value = parseInt(targetEl.value) + 1
            }
        })
    
        minButton.addEventListener('click', () => {
            if (parseInt(targetEl.value) > 0) {
                targetEl.value = parseInt(targetEl.value) - 1
            }

            isGuestEmpty()
        })
    }

    if (targetElChild) {
        // targetElChild.setAttribute('readonly', true)
    
        targetElChild.value = 0
        
        plusButtonChild.addEventListener('click', () => {
            if (parseInt(targetElChild.value) < 10) {
                targetElChild.value = parseInt(targetElChild.value) + 1
            }
        })
    
        minButtonChild.addEventListener('click', () => {
            if (parseInt(targetElChild.value) > 0) {
                targetElChild.value = parseInt(targetElChild.value) - 1
            }

            isGuestEmpty()
        })
    }

    targetEl.addEventListener('input', () => {
        isGuestEmpty()
    })

    targetElChild.addEventListener('input', () => {
        isGuestEmpty()
    })

}

function disableSubmitForm() {
    const submitBtn = document.querySelector('.wpcf7-submit')

    if (!submitBtn) return

    submitBtn.addEventListener('click', () => {
        submitBtn.classList.add('disabled')
    })
}

function showSuccessModal() {
    const modal = new Modal('#successModal')
    
    if (!modal) return

    modal.show()
}

function timeFlatpickr() {
    flatpickr(".preferedTime", {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
        inline: true,
        defaultDate: "00:00"
    });
}

function resetAdditionalServiceForm() {
    const selectTags = document.querySelector('#airport_transportation')

    if (!selectTags) return

    setTimeout(() => {
        selectTags.selectedIndex = 0
    }, 500);
}

function appendUserInfo() {
    // add user info getting from php to other activity form

    const formEmail = document.querySelector('#wpcf7-f445-o1 #email')
    const formPhone = document.querySelector('#wpcf7-f445-o1 #phone')
    const formFullname = document.querySelector('#wpcf7-f445-o1 #fullName')

    if (!formEmail) return

    formEmail.value = userInfoPhp.email
    formPhone.value = userInfoPhp.phone
    formFullname.value = userInfoPhp.name
}

function setActivityTitleForm() {
    const activityForm = document.querySelector('#wpcf7-f445-o1 #selected-activity')

    if (!activityForm) return

    activityForm.value = activityTitlePhp
}

document.addEventListener('DOMContentLoaded', () => {
    initFancyBox()
    gallerySwiper()
    galleryCursor()
    initReadsmore()
    copyLink()
    appendJetbooking()
    choicesJs()
    incrementNumberGuest()
    disableSubmitForm()
    timeFlatpickr()
    resetAdditionalServiceForm()
    appendUserInfo()
    setActivityTitleForm()
})

document.addEventListener( 'wpcf7mailsent', function( event ) {
    showSuccessModal()
}, false );

document.addEventListener( 'wpcf7submit', function( event ) {
    const submitBtn = document.querySelector('.wpcf7-submit')
    submitBtn.classList.remove('disabled')
}, false );